function isNullOrUndefined(aObject) {
    "use strict";
    return (typeof aObject === 'undefined' || aObject === null);
}

if (isNullOrUndefined(veritracks.system)) {
    veritracks.system = {};
}

veritracks.system.redirectToLogin = function (aReturnUrl) {
    "use strict";
    var lReturnURL;
    clearCdcrLoginAcknowledgmentSession(gUserDetails);
    if (isNullOrUndefined(aReturnUrl)) {
        lReturnURL = encodeURIComponent(window.location.pathname) + escape(window.location.hash);
    } else {
        lReturnURL = aReturnUrl;
    }

    // window.location.href = window.location.origin +'?ReturnUrl=' + lReturnURL;
};

veritracks.system.logout = function () {
    "use strict";
    clearCdcrLoginAcknowledgmentSession(gUserDetails);
    veritracks.terminateLogging();
    veritracks.security.controller.expireSession();

    // set timeout to allow clearing of data and ending of logging.....
    window.setTimeout(function (self) {
        self.redirectToLogin('..%2f');
    }, 100, this);
};

veritracks.system.raiseFailure = function (aFailureMessage) {
    "use strict";
    top.name = aFailureMessage;
    window.location.href = window.location.origin +'/Account/Fail.htm';
};

//// ES5 15.2.3.14 
//// http://es5.github.com/#x15.2.3.14 
//if (!Object.keys) {
//    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation 
//    var hasDontEnumBug = true,
//        dontEnums = [
//            "toString",
//            "toLocaleString",
//            "valueOf",
//            "hasOwnProperty",
//            "isPrototypeOf",
//            "propertyIsEnumerable",
//            "constructor"
//        ],
//        dontEnumsLength = dontEnums.length;

//    for (var key in { "toString": null }) {
//        hasDontEnumBug = false;
//    }

//    Object.keys = function keys(object) {

//        if ((typeof object != "object" && typeof object != "function") || object === null) {
//            throw new TypeError("Object.keys called on a non-object");
//        }

//        var keys = [];
//        for (var name in object) {
//            if (owns(object, name)) {
//                keys.push(name);
//            }
//        }

//        if (hasDontEnumBug) {
//            for (var i = 0, ii = dontEnumsLength; i < ii; i++) {
//                var dontEnum = dontEnums[i];
//                if (owns(object, dontEnum)) {
//                    keys.push(dontEnum);
//                }
//            }
//        }
//        return keys;
//    };
//} 

function count(aList) {
    "use strict";
    var lKey = null,
        lResult = 0;

    if (!isNullOrUndefined(aList)) {
        if (!isNullOrUndefined(Object.keys)) {
            lResult = Object.keys(aList).length;
        } else {
            for (lKey in aList) {
                if (aList.hasOwnProperty(lKey)) {
                    lResult++;
                }
            }
        }
    }
    return lResult;
}
//function count(aList) {
//    "use strict";
//    var lKey = null,
//            lResult = 0;
//    if (!isNullOrUndefined(aList)) {
//        if (aList.constructor == Array) {
//            lResult = aList.length;
//        } else if (!isNullOrUndefined(Object.keys)) {
//            lResult = Object.keys(aList).length;
//        } else {
//            for (lKey in aList) {
//                if (aList.hasOwnProperty(lKey)) {
//                    lResult++;
//                }
//            }
//        }
//    }
//    return lResult;
//}

function getKeys(aHash) {
    "use strict";
    var lKey = null, lResult = [];
    if (!isNullOrUndefined(aHash)) {
        if (!isNullOrUndefined(Object.keys)) {
            lResult = Object.keys(aHash);
        } else {
            for (lKey in aHash) {
                if (aHash.hasOwnProperty(lKey)) {
                    lResult.push(lKey);
                }
            }
        }
    }
    return lResult;
}